// 負載+自發自用+儲能+遠程綠電轉供 VPP0008
export const origin = {
    monthAllWheeling: 2500, //月度轉供量
    yearAllWheeling: 21617.64, //年度轉供量
    monthWheelingLimit: 2500, //月度轉供量上限
    yearWheelingLimit: 30000, //年度轉供量上限
    carbon: 1437.19, //當月減碳量
    ucAllRe: 0.80, //調度前RE
    re: 0.90, //調度後RE 
    maxDemand: 19.04, //最大需量
    demandLimit: 20, //契約容量
    saveFine: 4180.4, //契約容量節省
    excludeDispatchBill: 6506.44, //原始電費
    selfSubstituteValue: 1193.8, //綠能節省
    ucGrayBill: 14691.05, //調度前灰電電費
    grayBill: 12269.15, //調度後灰電電費
    demandResponseDeduction: 1103.65, // 需量反應扣減金額
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
    greenReport: {
        latestGreenEnergy: 2500,
        latestGreenBill: 12500,
        yearlyGreenEnergy: 21617.64,
        yearlyGreenEnergyLimit: 30000,
        yearlyGreenBill: 108088.2,
        yearlyCarbonReduction: 12008.7,
        yearlyCertificateAmount: 21,
        re: 77.9,
        greenTableData: [
            {
                powerNumberID: "06-35-6957-06-3",
                powerNumberName: "竹三辦微電網",
                greenPower: (21617.64).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ' kWh',
                greenBill: (108088.2).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ' NTD',
                carbonReduction: (12008.7).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ' kg',
                key: 1,
            },
        ],
        greenChartData: [
            {
                greenPower: 2167.88,
                carbonReduction: 2167.88,
                grayPower: 3015.66,
                re: (2167.88 / 3015.66).toFixed(2),
                time: "2025-01",
            },
            {
                greenPower: 2111.21,
                carbonReduction: 938.06,
                grayPower: 2399.36,
                re: (2111.21 / 2399.36).toFixed(2),
                time: "2025-02",
            },
            {
                greenPower: 2338.55,
                carbonReduction: 991.55,
                grayPower: 2656.54,
                re: (2338.55 / 2656.54).toFixed(2),
                time: "2025-03",
            },
            {
                greenPower: 2500,
                carbonReduction: 1178.52,
                grayPower: 2846.14,
                re: (2500 / 2846.14).toFixed(4),
                time: "2025-04",
            },
            {
                greenPower: 2500,
                carbonReduction: 1426.99,
                grayPower: 2913.07,
                re: (2500 / 2913.07).toFixed(4),
                time: "2025-05",
            },
            {
                greenPower: 2500,
                carbonReduction: 1259.83,
                grayPower: 2947.52,
                re: (2500 / 2947.52).toFixed(4),
                time: "2025-06",
            },
            {
                greenPower: 2500,
                carbonReduction: 1305.3,
                grayPower: 3807.31,
                re: (2500 / 3807.31).toFixed(4),
                time: "2025-07",
            },
            {
                greenPower: 2500,
                carbonReduction: 1437.19,
                grayPower: 3356.34,
                re: (2500 / 3356.34).toFixed(4),
                time: "2025-08",
            },
            {
                greenPower: 2500,
                carbonReduction: 1303.38,
                grayPower: 3815.8,
                re: (2500 / 3815.8).toFixed(4),
                time: "2025-09",
            },
        ]
    }
}

//自發自用+遠程綠電轉供 VPP0009
export const scene1 = {
    monthAllWheeling: 1130.83, //月度轉供量
    yearAllWheeling: 20248.47, //年度轉供量
    monthWheelingLimit: 2500, //月度轉供量上限
    yearWheelingLimit: 30000, //年度轉供量上限
    carbon: 419.63, //當月減碳量
    ucAllRe: 0.80, //調度前RE
    re: 0.90, //調度後RE 
    maxDemand: 19.04, //最大需量
    demandLimit: 20, //契約容量
    saveFine: 4180.44, //契約容量節省
    excludeDispatchBill: 6506.44, //原始電費
    selfSubstituteValue: 1193.8, //綠能節省
    ucGrayBill: 2513.25, //調度前灰電電費
    grayBill: 2091.35, //調度後灰電電費
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
}

//負載+自發自用+儲能 VPP0004
export const scene2 = {
    carbon: 93.27, //當月減碳量
    ucAllRe: 0.4, //調度前RE
    re: 0.58, //RE
    maxDemand: 18.42, //最大需量
    demandLimit: 20, //契約容量
    saveFine: 9294.88, //契約容量節省
    selfSubstituteValue: 823.44, //綠能節省
    ucGrayBill: 9968, //調度前灰電電費
    grayBill: 8965.28, //調度後灰電電費
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
}

//負載+儲能+遠程綠電轉供 VPP0006
export const scene3 = {
    monthWheelingLimit: 2500, //月度轉供量上限
    yearWheelingLimit: 30000, //年度轉供量上限
    ucAllRe: 0, //調度前RE
    re: 0.81, //RE
    maxDemand: 18.82, //最大需量
    demandLimit: 20, //契約容量
    saveFine: 0, //契約容量節省
    selfSubstituteValue: 0, //綠能節省
    ucGrayBill: 0, //調度前灰電電費
    grayBill: 0, //調度後灰電電費
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
}

//負載+充電樁 VPP0007
export const scene4 = {
    carbon: 0, //當月減碳量
    ucAllRe: 0, //調度前RE
    re: 0, //RE
    maxDemand: 24.69, //最大需量
    demandLimit: 25, //契約容量
    saveFine: 0, //契約容量節省
    selfSubstituteValue: 0, //綠能節省
    ucGrayBill: 0, //調度前灰電電費
    grayBill: 0, //調度後灰電電費
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
}

//負載+儲能 VPP0005
export const scene5 = {
    carbon: 0, //當月減碳量
    ucAllRe: 0, //調度前RE
    re: 0, //RE
    maxDemand: 18.43, //最大需量
    demandLimit: 20, //契約容量
    saveFine: 0, //契約容量節省
    selfSubstituteValue: 0, //綠能節省
    ucGrayBill: 0, //調度前灰電電費
    grayBill: 0, //調度後灰電電費
    soh: 100, //儲能SOH
    monthlyTotalAlerts: 0, //當月異常資料總數
    monthlyRepairedAlerts: 0, //當月已修復異常資料
}
